import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ColorPaletteIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="colorPalette" ref={ref} {...props}>
      <path d="M18.68,11.12A1.38,1.38,0,1,1,17.3,9.74,1.37,1.37,0,0,1,18.68,11.12ZM14.56,5.91a1.38,1.38,0,1,0,1.37,1.37A1.37,1.37,0,0,0,14.56,5.91Zm-5,0a1.38,1.38,0,0,0,0,2.75,1.38,1.38,0,1,0,0-2.75Zm-3,3.83A1.38,1.38,0,1,0,8,11.12,1.38,1.38,0,0,0,6.57,9.74Zm6.59,11.57A1.2,1.2,0,0,0,13,19.9a2.41,2.41,0,0,1-.5-1.58c0-.75.87-1.57,2.26-1.57,3.18,0,7-1.46,7.21-5.59a8.44,8.44,0,0,0-2.29-6.32A9.8,9.8,0,0,0,12.41,2C6.11,2,2,5.82,2,11.81c0,7.13,6.35,9.42,7.63,9.81a7.51,7.51,0,0,0,2.11.42A1.41,1.41,0,0,0,13.16,21.31Zm-.64-.41h0Zm6.06-15a7,7,0,0,1,1.88,5.21c-.23,4-4.79,4.17-5.71,4.17-2.35,0-3.76,1.56-3.76,3.07a3.84,3.84,0,0,0,.61,2.21,7.82,7.82,0,0,1-1.5-.34C9,19.85,3.54,17.88,3.54,11.81c0-5.15,3.4-8.35,8.87-8.35A8.35,8.35,0,0,1,18.58,5.87Z" />
    </Icon>
  ),
) as IconWithRender;

ColorPaletteIcon.displayName = 'ColorPaletteIcon';
ColorPaletteIcon.renderIcon = (props) => <ColorPaletteIcon {...props} />;
export default ColorPaletteIcon;
